import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageBg } from '../shared/usePageBg';
import { usePageBgGradient } from '../shared/usePageBgGradient';
import HeroSection from './HeroSection/HeroSection';
import TryItOut from './TryItOut/TryItOut';
import Workflow from './Workflow/Workflow';
import WebReport from './WebReport/WebReport';
import BusinessTools from './BusinessTools/BusinessTools';
import Proof from './Proof/Proof';
import Comparison from './Comparison/Comparison';
import Pricing from './Pricing/Pricing';
import InternachiPricing from './Pricing/InterNachiPricing';
import Download from './Download/Download';
import AboutUs from './AboutUs/AboutUs';

interface MainContentProps {
  isMobile: boolean;
  isTablet: boolean;
  setToastMessage: (message: string) => void;
  setShowToast: (showToast: boolean) => void;
  openWaitlist?: () => void;
}

const MainContent: React.FC<MainContentProps> = ({
  isMobile,
  setToastMessage,
  setShowToast,
  openWaitlist,
}) => {
  const location = useLocation();
  const isInternachi = location.pathname.startsWith(
    '/InterNACHI-discount-ji394su3pa7',
  );

  usePageBg();
  usePageBgGradient();

  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash) return;
      const id = hash.split('?')[0].substring(1);
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };
    const t = setTimeout(scrollToHash, isMobile ? 300 : 100);
    return () => clearTimeout(t);
  }, [location, isMobile]);

  return (
    <main className="main-content">
      <HeroSection />
      <TryItOut
        setToastMessage={setToastMessage}
        setShowToast={setShowToast}
        openWaitlist={openWaitlist}
      />
      <Workflow />
      <WebReport />
      <BusinessTools />
      <Proof />
      <Comparison />
      {isInternachi ? <InternachiPricing /> : <Pricing />}
      <Download />
      <AboutUs />
    </main>
  );
};

export default MainContent;
